import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'BONUS #1 : Le Guide du Style Post-Divorce',
  description: 'Ta nouvelle Signature Visuelle pour rallumer ton charisme et te sentir "Femme" en 5 minutes le matin. Sans te ruiner.',
  value: '47$',
  image: 'https://cdn.magicpatterns.com/uploads/qk4eNB59s83MvCyPwPd58z/BONUS_1.png'
}, {
  title: "BONUS #2 : L'Agenda de la Liberté",
  description: 'Le template secret pour gagner 15 min de vrai calme par jour.',
  value: '27$',
  image: 'https://cdn.magicpatterns.com/uploads/gvYqouCyPQDSpF229quX3j/BONUS_2.png'
}, {
  title: 'BONUS #3 : 50 Activités de Renaissance à 0$',
  description: 'Ne laisse plus jamais la solitude gagner le dimanche soir.',
  value: '37$',
  image: 'https://cdn.magicpatterns.com/uploads/4EUr2b5byjLjkLekHRrv55/BONUS_3.png'
}, {
  title: "BONUS #4 : Le Manifeste de l'Estime de Soi",
  description: '30 affirmations puissantes pour couper court à la culpabilité chaque matin',
  value: '27$',
  image: 'https://cdn.magicpatterns.com/uploads/cWvYzi3KMq6VeZs7hJKmMm/BONUS_4.png'
}];
export function OfferSection() {
  return <section className="bg-cream py-10 px-6 md:py-16" data-id="element-198">
      <div className="max-w-5xl mx-auto" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-200">
          <h2 className="font-playfair text-3xl md:text-4xl text-charcoal text-center mb-8" data-id="element-201">
            Voici tout ce que tu reçois aujourd'hui dans le Pack "RE-NAISSANCE"
            :
          </h2>

          <div className="bg-white p-8 rounded-lg shadow-lg mb-8 border-2 border-gold" data-id="element-202">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-203">
              <img src="https://cdn.magicpatterns.com/uploads/4f8oP9vupbaJBysmD7wbRq/COVER.png" alt="RE-NAISSANCE" className="w-48 shadow-xl rounded-lg" data-id="element-204" />
              <div className="flex-1" data-id="element-205">
                <h3 className="font-playfair text-2xl text-burgundy mb-3" data-id="element-206">
                  Le Système Principal : "RE-NAISSANCE"
                </h3>
                <p className="text-lg mb-4" data-id="element-207">
                  La méthode étape par étape pour te retrouver en 30 jours.
                </p>
                <p className="text-lg text-gray-500 line-through" data-id="element-208">
                  Valeur : 97$
                </p>
                <p className="text-2xl font-bold text-burgundy" data-id="element-209">
                  Prix aujourd'hui : 14.97$
                </p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-5 mb-8" data-id="element-210">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-lg shadow-md" data-id="element-211">
                <img src={bonus.image} alt={bonus.title} className="w-full aspect-square object-cover rounded-lg mb-4" data-id="element-212" />
                <h3 className="font-playfair text-xl text-burgundy mb-2" data-id="element-213">
                  {bonus.title}
                </h3>
                <p className="text-charcoal mb-3" data-id="element-214">{bonus.description}</p>
                <div className="flex items-center justify-between" data-id="element-215">
                  <p className="text-sm text-gray-600" data-id="element-216">
                    Valeur : {bonus.value}
                  </p>
                  <span className="bg-gold text-white px-3 py-1 rounded-full text-sm font-semibold" data-id="element-217">
                    GRATUIT aujourd'hui
                  </span>
                </div>
              </motion.div>)}
          </div>

          <div className="text-center space-y-4" data-id="element-218">
            <p className="text-2xl" data-id="element-219">
              VALEUR TOTALE :{' '}
              <span className="line-through text-gray-500" data-id="element-220">235$</span>
            </p>
            <p className="text-2xl font-playfair font-semibold text-charcoal" data-id="element-221">
              PRIX AUJOURD'HUI :
            </p>
            <p className="text-5xl font-playfair font-bold text-burgundy" data-id="element-222">
              14.97$
            </p>
          </div>

          <div className="bg-burgundy rounded-lg py-8 px-6 mt-8 text-center flex flex-col items-center" data-id="element-223">
            <p className="font-playfair italic text-2xl md:text-3xl text-cream leading-relaxed" data-id="element-224">
              "Le prix d'une pizza.
            </p>
            <p className="font-playfair italic text-2xl md:text-3xl text-cream leading-relaxed mt-2" data-id="element-225">
              L'impact d'une thérapie."
            </p>
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-white text-burgundy px-6 py-4 rounded-lg text-lg font-semibold hover:bg-opacity-90 transition-all shadow-lg mt-6" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-226">
              Oui, Je Mérite Ma Renaissance →
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>;
}